import {
    getDataWithParams,
    postData, 
    destroyData
} from '@/store/config/method'

const initRequest = {
    page: 1,
    show: 10,
    sortBy: "created_at",
    sorting: "DESC",
    search: null,
}
const initItem = {
    id: null,
    link: null,
    order: 1,
    picture: null,
    is_active: false,
}
const initialState = () => ({
    message: 'Jaringan Bermasalah',
    status: 0,
    request: {...initRequest},
    list: {last_page: 0, data: [], total: 0},
    item: {...initItem},
    sliders: []
})
const state = initialState
const getters = {
    getStatus: state => state.status,
    getMsg: state => state.message,
    getRequest: state => state.request,
    getList: state => state.list,
    getItem: state => state.item,
    getSliders: state => state.sliders || []
}

const actions = {
    resetItem({commit}){
        commit('SET_ITEM', {...initItem})
    },
    setItem({commit}, item){
        commit('SET_ITEM', {...item})
    },
    async getSlidersData({
        commit
    }) {
        try {
            const url = '/sliders/landing'
            const response = await getDataWithParams(url, {});
            commit('SET_RESPONSE', response.data);
            commit('SET_SLIDERS_DATA', response.data.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MSG', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async getData({
        commit, state
    }) {
        try {
            const url = '/sliders'
            const response = await getDataWithParams(url, state.request);
            commit('SET_RESPONSE', response.data);
            commit('SET_LIST', response.data.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MSG', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async store({
        commit
    }, payload){
        try {
            const url = '/sliders'
            const response = await postData(url, payload);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MSG', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async update({
        commit
    }, {payload, id}){
        try {
            const url = `/sliders/${id}`
            const response = await postData(url, payload);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MSG', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async destroy({
        commit
    }, id){
        try {
            const url = `/sliders${id}`
            const response = await destroyData(url);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MSG', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    }
    
}

const mutations = {
    SET_FAILED(state) {
        state.message = 'Jaringan Bermasalah'
        state.status = 0
    },
    SET_FAILED_MSG(state, error) {
        if(error.status == 400){
            state.message = error.data.msg
            state.status = error.data.status
        }else{
            state.message = 'Jaringan Bermasalah'
            state.status = 0
        }
    },
    SET_RESPONSE(state, response){
        state.message = response.msg
        state.status = response.status
    },
    SET_LIST(state, value){
        state.list = value
    },
    SET_ITEM(state, value){
        state.item = value
    },
    SET_SLIDERS_DATA(state, value){
        state.sliders = value
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}